<script>
import options from "./NykDateTimePicker.options"
export default options
</script>

<template>
    <div class="nyk-form-element" :class="{ 'nyk-form-element--validation-failed': errorMessage }">
      <div class="nyk-form-element__content">
        <input :ref="el => inputElement = el"
          :id="name"
          :name="name"
          type="text"
          class="nyk-form-element__content__input"
          :aria-describedby="errorMessage ? `description-${name}-error` : `description-${name}`"
          :aria-invalid="!!errorMessage"
          :aria-required="required"
          :invalid="!!errorMessage"
          :autocomplete="autoComplete"
          :max="maxDate"
          :min="minDate"
          :maxlength="maxLength"
          :placeholder="label"
          :value="value"
          v-bind="attributes"
          v-on="validationListeners"
          @input.prevent.stop="onInputChange"
          @select.prevent.stop
          @focus="onFocus"
          @blur.prevent.stop="onBlur"
          @keydown="onKeyDown">
        <label :for="name" class="nyk-form-element__content__label">{{ label }}</label>
        <button @click="resetInputValue" type="button" class="nyk-form-element__content__reset-icon" :aria-label="clearButtonAriaLabel">
          <span class="nyk-icon nyk-icon--ui-close"></span>
        </button>
        <div v-if="errorMessage" class="nyk-form-element__content__error-icon">
            <span class="nyk-icon nyk-icon--ui-form-error"></span>
        </div>
      </div>
      <span class="nyk-form-element__help-message" :id="`description-${name}`">{{ description }}</span>
      <span v-if="errorMessage" class="nyk-form-element__error-message" :id="`description-${name}-error`" aria-live="polite">{{ errorMessage }}</span>
    </div>
</template>